export default "__VITE_ASSET__DfmKTO4L__"